import React, { PureComponent } from 'react'
import { Jumbotron } from 'reactstrap'

class ServicoIndisponivel extends PureComponent {
    render() {
        return (
            <div className="container">
                <Jumbotron>
                    <h1>Serviço temporariamente indisponível</h1>
                    <p>Neste momento o serviço está em manutenção, por favor tente novamente mais tarde.</p>
                </Jumbotron>
            </div>
        )
    }
}

export default ServicoIndisponivel